module.exports = __webpack_public_path__ + "static/media/test-tv.bee55f9e.jpg";